import { MainColor } from '../../palette/colors';

export const getToDoListTheme = () => {
  return {
    emptyState: {
      title: 'navy95' satisfies MainColor as MainColor,
    },
    task: {
      item: 'coolGrey80' satisfies MainColor as MainColor,
      amount: 'coolGrey60' satisfies MainColor as MainColor,
      background: 'white95' satisfies MainColor as MainColor,
      subItemBackground: 'coolGrey10' satisfies MainColor as MainColor,
      focusBackground: 'navy10' satisfies MainColor as MainColor,
      hoverBackground: 'navy10' satisfies MainColor as MainColor,
      border: 'coolGrey10' satisfies MainColor as MainColor,
      borderAlt: 'coolGrey30' satisfies MainColor as MainColor,
      components: {
        circleIcon: 'coolGrey60' satisfies MainColor as MainColor,
        circleIconBg: 'coolGrey5' satisfies MainColor as MainColor,
        circleIconBorder: 'coolGrey20' satisfies MainColor as MainColor,
        squareIcon: 'navy80' satisfies MainColor as MainColor,
        filters: {
          border: 'coolGrey30' satisfies MainColor as MainColor,
        },
        checkbox: {
          greenCheckmark: 'green50' satisfies MainColor as MainColor,
          checkboxFill: 'navy60' satisfies MainColor as MainColor,
          focus: 'navy10' satisfies MainColor as MainColor,
          icon: 'coolGrey60' satisfies MainColor as MainColor,
          border: 'coolGrey10' satisfies MainColor as MainColor,
        },
        addToPlan: {
          infoColor: 'navy50' satisfies MainColor as MainColor,
          infoBorder: 'navy10' satisfies MainColor as MainColor,
        },
      },
    },
    filters: {
      background: 'coolGrey5' satisfies MainColor as MainColor,
      border: 'coolGrey30' satisfies MainColor as MainColor,
      label: 'coolGrey60' satisfies MainColor as MainColor,
      toggleLabel: 'navy95' satisfies MainColor as MainColor,
    },
  };
};

export type ToDoListTheme = ReturnType<typeof getToDoListTheme>;
